import React, { useState } from "react";
import { Tabs, TabsPanel } from "@salesforce/design-system-react";
import { ToastState } from "../../../utils/types/toast";
import { CONSTANT_ACCOUNT } from "../../../constants/accountManagement";
import StackSetDrift from "./stackset_drift/StackSetDrift";
import SCPDrift from "./scp_drift/SCPDrift";

type DriftProps = {
    isActive: boolean;
    setActiveTab: (tab: string) => void;
    setActiveSubTab: (tabIndex: number) => void;
    setToast: React.Dispatch<React.SetStateAction<ToastState>>;
};

const Drift: React.FC<DriftProps> = ({ isActive, setActiveTab, setActiveSubTab, setToast }) => {
    const [activeDriftTab, setActiveDriftTab] = useState<number>(0);

    const handleDriftTabSelect = (selectedIndex: number) => {
        setActiveDriftTab(selectedIndex);
    };

    return (
        <div className="slds-is-relative slds-size_1-of-1">
            <Tabs
                variant="scoped"
                id="drift_tabs"
                selectedIndex={activeDriftTab}
                onSelect={handleDriftTabSelect}
            >
                <TabsPanel label={CONSTANT_ACCOUNT.STACKSET_DRIFT}>
                    <StackSetDrift
                        isActive={isActive && activeDriftTab === 0}
                        setActiveTab={setActiveTab}
                        setActiveSubTab={setActiveSubTab}
                        setToast={setToast}
                    />
                </TabsPanel>
                <TabsPanel label={CONSTANT_ACCOUNT.SCP_DRIFT}>
                    <SCPDrift
                        isActive={isActive && activeDriftTab === 1}
                        setActiveTab={setActiveTab}
                        setActiveSubTab={setActiveSubTab}
                        setToast={setToast}
                    />
                </TabsPanel>
            </Tabs>
        </div>
    );
};

export default Drift;
